import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './context/AuthContext';
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import TrainerProfile from './pages/TrainerProfile';
import Admin from './pages/Admin';
import BecomeTrainer from './pages/BecomeTrainer';
import TrainerDashboard from './pages/TrainerDashboard';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import Terms from './pages/Terms';
import Messages from './pages/Messages';
import MyTraining from './pages/MyTraining';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/trainer/:id" element={<TrainerProfile />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/become-a-trainer" element={<BecomeTrainer />} />
          <Route path="/trainer/dashboard" element={<TrainerDashboard />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/my-training" element={<MyTraining />} />
        </Routes>
        <Toaster 
          position="top-center" 
          toastOptions={{
            style: {
              background: '#141414',
              color: '#fff',
              border: '1px solid rgba(255,255,255,0.1)'
            }
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
